import { z } from 'zod';
export const FieldValueSchema = z.lazy(() => z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.object({}),
    z.array(FieldValueSchema),
    z.record(z.string(), FieldValueSchema)
]));
//# sourceMappingURL=field-value.js.map